import { useQuery } from 'hooks'

export const getPublicFeatureFlagsUrl = (orgId: string) => `/c/v1/feature-flags-public?orgId=${orgId}`

export const useIsAnonymousQuizEnabled = (orgId: string) => {
    const { data, error } = useQuery<{ enableAnonymousQuiz?: boolean }>(orgId ? getPublicFeatureFlagsUrl(orgId) : '', {
        method: 'GET',
    })

    return {
        isAnonymousQuizEnabled: data?.enableAnonymousQuiz === true,
        isLoading: Boolean(orgId) && !data && !error,
    }
}
